import React, { useEffect, useState } from "react";
import { getTopCreators, getUserProfile } from "../../Services/ShowsApi";
import light from "../../Assests/Light.svg";
import { MarginRounded } from "@mui/icons-material";
import profileIcon from "../../Assests/profile.png";
import ConnectButton from "../../Components/ConnectButton";
import { useDispatch } from "react-redux";
import { API_STATUS } from "../../utils/constant";
import { clearSearchUserData, setSearchUserData, setValue } from "../../redux/valueSlice";
import { setProfileShow } from "../../redux/notificationSlice";
import { Tooltip } from "@mui/material";
import { useLoader } from "../../Components/LoaderContext";
import { Select, MenuItem, FormControl, InputLabel } from '@mui/material';
import { getCreators } from "../../Data/dataStore";
import { maxHeight } from "@mui/system";
import { capitalizeNames } from "../../utils/nameUtils";

const CreatorCard = ({ FirstName, LastName, ShowCount, ProfileImageKey, ConnectionStatus, UserID }) => {
  const dispatch = useDispatch();
  const { triggerLoader, hideLoader } = useLoader();

  const handleClickViewProfile = async () => {
    triggerLoader("Loading profile...");
    dispatch(clearSearchUserData());
    const res = await getUserProfile(UserID);
    console.log("res==", res)
    if (res?.status.toString() === API_STATUS.success) {
      const { body } = res?.data;
      const { Data } = body;

      dispatch(setValue({ viewSearchProfile: true, viewFromRequests: false }));
      dispatch(setSearchUserData(Data[0]));
      dispatch(setProfileShow(true));
    }
    hideLoader();
  };

  return (
    <div style={styles.creatorCard}>
      <div
        style={styles.creatorInfo}
        className="pointer"
        onClick={handleClickViewProfile}
      >
        <Tooltip title="View Profile">
          <div
            style={{
              ...styles.avatar,
              backgroundImage: `url(${ProfileImageKey || profileIcon})`,
            }}
          />
        </Tooltip>
        <div style={styles.creatorDetails}>
          <Tooltip title="View Profile">
            <div style={styles.creatorName}>{capitalizeNames(FirstName, LastName).fullName}</div>
          </Tooltip>
          {/* <div style={styles.creatorRole}>{ShowCount}</div> */}
        </div>
      </div>
      <ConnectButton ConnectionStatus={ConnectionStatus} ReceiverID={UserID} />
    </div>
  );
};

const Creators = ({ creators, onDropdownChange }) => {
  const [selectedValue, setSelectedValue] = useState("all_time");

  const handleDropdownChange = (event) => {
    const selectedValue = event.target.value;
    console.log("Selected value:", selectedValue);
    // Notify the parent component about the dropdown change
    onDropdownChange(selectedValue);
    setSelectedValue(event.target.value);
  };

  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <div style={styles.title}>Top Collaborators</div>


        <FormControl style={styles.dropdown}>
          {/* <InputLabel id="timeframe-label">Timeframe</InputLabel> */}
          {/* <Select
            labelId="timeframe-label"
            value={selectedValue}
            onChange={handleDropdownChange}
            // label="Timeframe"
            sx={{
              color: 'white',
              '.MuiSvgIcon-root': {
                color: 'white',
              },
            }}
          >
            <MenuItem value="all_time">All Time</MenuItem>
            <MenuItem value="last_week">Last Week</MenuItem>
            <MenuItem value="last_month">Last Month</MenuItem>
            <MenuItem value="last_year">Last Year</MenuItem>
          </Select> */}
        </FormControl>


      </div>
      <div style={styles.creatorList}>
        {creators.length > 0 ? (
          <>
            {creators.map((creator, index) => (
              <CreatorCard key={index} {...creator} />
            ))}
          </>
        ) : (
          <div>
            No creators found.
          </div>
        )}
      </div>
    </div>
  );
};

const styles = {
  container: {
    width: "100%",
    height: "100%",
    padding: '1.6vh',
    background: "rgba(0, 0, 0, 0.10)",
    overflow: "hidden",
    borderRadius: '2.4vh',
    outline: "0.1vh rgba(175.31, 175.31, 175.31, 0.20) solid",
    outlineOffset: "-0.1vh",
    display: "flex",
    flexDirection: "column",
    gap: '1.6vh',
  },
  title: {
    alignSelf: "stretch",
    color: "white",
    fontSize: '1.8vh',
    fontWeight: "bolder",
    letterSpacing: '0.144vh',
    wordWrap: "break-word",
    alignContent: "center"
  },
  dropdown: {
    fontSize: "1.6vh",
    borderRadius: "1.3vh",
    cursor: "pointer",
    backgroundColor: "rgba(255, 255, 255, 0.08)",
    width: '30%',
    color: "white",
  },
  option: {
    backgroundColor: "rgba(255, 255, 255, 0.08)",
    color: "black",
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "1vh",
  },
  creatorList: {
    alignSelf: "stretch",
    flex: 1,
    overflow: "hidden",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "center",
    gap: '0.8vh',
    overflowY: "auto",
    scrollbarWidth: "none",
    msOverflowStyle: "none",
    "&::-webkit-scrollbar": {
      display: "none",
    },
  },
  creatorCard: {
    alignSelf: "stretch",
    padding: "0.8vh 1.6vh",
    background: "rgba(71, 45, 219, 0.10)",
    borderRadius: '1.6vh',
    backdropFilter: "blur(0.8vh)",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  creatorInfo: {
    alignSelf: "stretch",
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    gap: '1.6vh',
  },
  avatar: {
    width: '4.2vh',
    height: '4.2vh',
    padding: '1.6vh',
    borderRadius: '6.4vh',
    backgroundSize: "cover",
    backgroundPosition: "center",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: '1vh',
  },
  creatorDetails: {
    alignSelf: "stretch",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "flex-start",
    gap: '0.8vh',
  },
  creatorName: {
    color: "white",
    fontSize: '1.6vh',
    fontWeight: "bolder",
    letterSpacing: '0.1vh',
    wordWrap: "break-word",
  },
  creatorRole: {
    color: "white",
    fontSize: '1.2vh',
    fontWeight: "bolder",
    letterSpacing: '0.024vh',
    wordWrap: "break-word",
  },
  connectButton: {
    padding: "0.8vh 1.6vh",
    background: "rgba(41, 104, 254, 0.8)",
    borderRadius: '1.6vh',
    overflow: "hidden",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: '0.8vh',
  },
  connectText: {
    textAlign: "right",
    color: "white",
    fontSize: '1.6vh',
    fontWeight: "bolder",
    letterSpacing: '0.064vh',
    wordWrap: "break-word",
  },
  connectIcon: {
    width: '2.4vh',
    height: '2.4vh',
    position: "relative",
    overflow: "hidden",
  },
  iconInner: {
    width: '1.6vh',
    height: '1.6vh',
    left: '0.4vh',
    top: '0.4vh',
    position: "absolute",
    background: "white",
  },
  button: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "0.8vh 1.6vh",
    backgroundColor: "rgba(41, 104, 254, 0.8)",
    color: "#fff",
    border: "none",
    borderRadius: '1.6vh',
    cursor: "pointer",
    fontSize: "1.6vh",
    fontWeight: "bold",
    transition: "background-color 0.3s ease",
    ":hover": {
      backgroundColor: "#0056b3",
    },
    ":active": {
      backgroundColor: "#004080",
    },
    gap: '0.8vh',
  },
};

const TopCreators = ({ width, height }) => {
  const containerStyle = {
    width: width || "100%", // Default to 100% if no width is provided
    maxHeight: height || "100%", // Default to 100% if no height is provided
  };

  // const [creators, setCreators] = useState([]);
  const [creators, setCreators] = useState(getCreators());
  const [selectedFilter, setSelectedFilter] = useState("all_time");

  const handleDropdownChange = (filter) => {
    setSelectedFilter(filter); // Update the selected filter
  };

  // Function to calculate start and end dates based on the selected filter
  const getDateRange = (filter) => {
    const endDate = new Date(); // End date is always the current date
    let startDate = new Date();

    switch (filter) {
      case "last_week":
        startDate.setDate(endDate.getDate() - 7); // Subtract 7 days
        break;
      case "last_month":
        startDate.setMonth(endDate.getMonth() - 1); // Subtract 1 month
        break;
      case "last_year":
        startDate.setFullYear(endDate.getFullYear() - 1); // Subtract 1 year
        break;
      case "all_time":
        startDate = null; // No start date for "All Time"
        break;
      default:
        startDate = null;
    }

    return { startDate, endDate };
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const { startDate, endDate } = getDateRange(selectedFilter);
        const response = await getTopCreators(startDate, endDate);
        console.log({ response });
        setCreators(response?.data?.body.Data);
      } catch (error) {
        console.error("Error fetching top creators:", error);
      }
    };

    fetchData();
  }, [selectedFilter]);

  return (
    <div style={containerStyle}>
      <Creators creators={creators} onDropdownChange={handleDropdownChange} />
    </div>
  );
};
export default TopCreators;
